import React from "react";

export const PlusIconWhite = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H12.75V19.5C12.75 19.9142 12.4142 20.25 12 20.25C11.5858 20.25 11.25 19.9142 11.25 19.5V12.75H4.5C4.08579 12.75 3.75 12.4142 3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25H11.25V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z"
      fill="white"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
      fill="#1C274C"
    ></path>
  </svg>
);

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 3.75C6.77208 3.75 3.75 6.77208 3.75 10.5C3.75 14.2279 6.77208 17.25 10.5 17.25C12.3642 17.25 14.0506 16.4953 15.273 15.273C16.4953 14.0506 17.25 12.3642 17.25 10.5C17.25 6.77208 14.2279 3.75 10.5 3.75ZM2.25 10.5C2.25 5.94365 5.94365 2.25 10.5 2.25C15.0563 2.25 18.75 5.94365 18.75 10.5C18.75 12.5078 18.032 14.3491 16.8399 15.7793L21.5303 20.4697C21.8232 20.7626 21.8232 21.2374 21.5303 21.5303C21.2374 21.8232 20.7626 21.8232 20.4697 21.5303L15.7793 16.8399C14.3491 18.032 12.5078 18.75 10.5 18.75C5.94365 18.75 2.25 15.0563 2.25 10.5Z"
      fill="#676A80"
    />
  </svg>
);

export const ToggleIconLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7906 14.7698C15.5035 15.0684 15.0287 15.0777 14.7302 14.7906L10.2302 10.5406C10.0831 10.3992 10 10.204 10 10C10 9.79599 10.0831 9.60078 10.2302 9.45938L14.7302 5.20937C15.0287 4.92228 15.5035 4.93159 15.7906 5.23017C16.0777 5.52875 16.0684 6.00353 15.7698 6.29062L11.8321 10L15.7698 13.7094C16.0684 13.9965 16.0777 14.4713 15.7906 14.7698ZM9.79062 14.7698C9.50353 15.0684 9.02875 15.0777 8.73017 14.7906L4.23017 10.5406C4.08311 10.3992 4 10.204 4 10C4 9.79599 4.08311 9.60078 4.23017 9.45938L8.73017 5.20938C9.02875 4.92228 9.50353 4.93159 9.79062 5.23017C10.0777 5.52875 10.0684 6.00353 9.76983 6.29062L5.83208 10L9.76983 13.7094C10.0684 13.9965 10.0777 14.4713 9.79062 14.7698Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuIconAnalytics = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.125 2.5C3.125 2.15482 2.84518 1.875 2.5 1.875C2.15482 1.875 1.875 2.15482 1.875 2.5V15.625C1.875 16.6605 2.71447 17.5 3.75 17.5H17.5C17.8452 17.5 18.125 17.2202 18.125 16.875C18.125 16.5298 17.8452 16.25 17.5 16.25H3.75C3.40482 16.25 3.125 15.9702 3.125 15.625V2.5ZM17.0086 6.11612C17.2527 5.87204 17.2527 5.47796 17.0086 5.23388C16.7645 4.98979 16.3705 4.98979 16.1264 5.23388L11.875 9.48528L9.63388 7.24413C9.39775 7.00799 9.01982 6.99925 8.77341 7.22431L5.27341 10.4243C5.01809 10.6578 4.99988 11.052 5.23338 11.3073C5.46688 11.5626 5.86108 11.5808 6.1164 11.3473L9.17915 8.54716L11.3911 10.7592C11.6352 11.0032 12.0293 11.0032 12.2734 10.7592L17.0086 6.11612ZM7.5 14.375C7.5 14.7202 7.22018 15 6.875 15C6.52982 15 6.25 14.7202 6.25 14.375V12.5C6.25 12.1548 6.52982 11.875 6.875 11.875C7.22018 11.875 7.5 12.1548 7.5 12.5V14.375ZM10.625 14.375C10.625 14.7202 10.3452 15 10 15C9.65482 15 9.375 14.7202 9.375 14.375V11.25C9.375 10.9048 9.65482 10.625 10 10.625C10.3452 10.625 10.625 10.9048 10.625 11.25V14.375ZM13.75 14.375C13.75 14.7202 13.4702 15 13.125 15C12.7798 15 12.5 14.7202 12.5 14.375V10C12.5 9.65482 12.7798 9.375 13.125 9.375C13.4702 9.375 13.75 9.65482 13.75 10V14.375ZM16.875 14.375C16.875 14.7202 16.5952 15 16.25 15C15.9048 15 15.625 14.7202 15.625 14.375V8.75C15.625 8.40482 15.9048 8.125 16.25 8.125C16.5952 8.125 16.875 8.40482 16.875 8.75V14.375Z'
      fill='#676A80'
    />
  </svg>
);

export const MenuIconDashboard = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 5.9375C1.25 5.07456 1.94956 4.375 2.8125 4.375H7.8125C8.67544 4.375 9.375 5.07456 9.375 5.9375V9.0625C9.375 9.92545 8.67544 10.625 7.8125 10.625H2.8125C1.94956 10.625 1.25 9.92544 1.25 9.0625V5.9375ZM11.25 7.1875C11.25 6.32456 11.9496 5.625 12.8125 5.625H17.1875C18.0504 5.625 18.75 6.32456 18.75 7.1875V14.0625C18.75 14.9254 18.0504 15.625 17.1875 15.625H12.8125C11.9496 15.625 11.25 14.9254 11.25 14.0625V7.1875ZM2.5 13.4375C2.5 12.5746 3.19956 11.875 4.0625 11.875H8.4375C9.30044 11.875 10 12.5746 10 13.4375V15.3125C10 16.1754 9.30044 16.875 8.4375 16.875H4.0625C3.19955 16.875 2.5 16.1754 2.5 15.3125V13.4375Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuIconDeviceManagement = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path d="M16.25 5H3.75V12.5H16.25V5Z" fill="#676A80" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.8125 2.5C1.94956 2.5 1.25 3.19955 1.25 4.0625V13.4375C1.25 14.3004 1.94955 15 2.8125 15H8.125V16.25H5C4.65482 16.25 4.375 16.5298 4.375 16.875C4.375 17.2202 4.65482 17.5 5 17.5H15C15.3452 17.5 15.625 17.2202 15.625 16.875C15.625 16.5298 15.3452 16.25 15 16.25H11.875V15H17.1875C18.0504 15 18.75 14.3004 18.75 13.4375V4.0625C18.75 3.19956 18.0504 2.5 17.1875 2.5H2.8125ZM2.8125 13.75H17.1875C17.3601 13.75 17.5 13.6101 17.5 13.4375V4.0625C17.5 3.88991 17.3601 3.75 17.1875 3.75H2.8125C2.63991 3.75 2.5 3.88991 2.5 4.0625V13.4375C2.5 13.6101 2.63991 13.75 2.8125 13.75Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuIconAlerts = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M14.0677 3.62135C12.3417 4.31183 10.4931 4.76116 8.5633 4.92767C8.00706 4.97566 7.44397 5.00017 6.875 5.00017H6.25C3.83375 5.00017 1.875 6.95892 1.875 9.37517C1.875 11.5415 3.44954 13.3401 5.51664 13.689C5.7952 14.8298 6.18171 15.9283 6.6647 16.973C7.05142 17.8095 8.05984 18.073 8.81691 17.6359L9.36384 17.3202C10.0972 16.8967 10.3352 15.9929 10.0072 15.2634C9.81152 14.8281 9.63685 14.3813 9.48452 13.9243C11.0823 14.1394 12.6182 14.5491 14.0677 15.129C14.6724 13.3212 15 11.3864 15 9.37515C15 7.36389 14.6724 5.42914 14.0677 3.62135Z"
      fill="#676A80"
    />
    <path
      d="M15.2172 3.11742C15.8867 5.0805 16.25 7.18541 16.25 9.37515C16.25 11.5649 15.8867 13.6698 15.2172 15.6329C15.1712 15.7677 15.1239 15.9019 15.0751 16.0353C14.9564 16.3595 15.123 16.7184 15.4472 16.8371C15.7713 16.9557 16.1303 16.7892 16.2489 16.465C16.3656 16.1463 16.4747 15.8238 16.5758 15.4979C17.0122 14.0923 17.3023 12.6225 17.4283 11.1066C17.8591 10.6579 18.125 10.0474 18.125 9.37517C18.125 8.70296 17.8591 8.09243 17.4283 7.64372C17.3023 6.12781 17.0122 4.65805 16.5758 3.25243C16.4747 2.92653 16.3656 2.60409 16.2489 2.28533C16.1303 1.96119 15.7713 1.7946 15.4472 1.91325C15.123 2.03191 14.9564 2.39086 15.0751 2.71501C15.1239 2.84844 15.1712 2.98263 15.2172 3.11742Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuIconDeviceSetUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M4.58917 3.37302C5.06413 2.81891 5.7575 2.5 6.48731 2.5H13.5126C14.2424 2.5 14.9357 2.81891 15.4107 3.37302L16.8456 5.04704C16.6516 5.01608 16.4526 5 16.2499 5H3.74994C3.54723 5 3.34828 5.01608 3.1543 5.04704L4.58917 3.37302Z"
      fill="#676A80"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25 8.75C1.25 7.36929 2.36929 6.25 3.75 6.25H16.25C17.6307 6.25 18.75 7.36929 18.75 8.75C18.75 10.1307 17.6307 11.25 16.25 11.25H3.75C2.36929 11.25 1.25 10.1307 1.25 8.75ZM13.75 8.75C13.75 9.09518 13.4702 9.375 13.125 9.375C12.7798 9.375 12.5 9.09518 12.5 8.75C12.5 8.40482 12.7798 8.125 13.125 8.125C13.4702 8.125 13.75 8.40482 13.75 8.75ZM15.625 9.375C15.9702 9.375 16.25 9.09518 16.25 8.75C16.25 8.40482 15.9702 8.125 15.625 8.125C15.2798 8.125 15 8.40482 15 8.75C15 9.09518 15.2798 9.375 15.625 9.375Z"
      fill="#676A80"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 12.5C2.36929 12.5 1.25 13.6193 1.25 15C1.25 16.3807 2.36929 17.5 3.75 17.5H16.25C17.6307 17.5 18.75 16.3807 18.75 15C18.75 13.6193 17.6307 12.5 16.25 12.5H3.75ZM13.125 15.625C13.4702 15.625 13.75 15.3452 13.75 15C13.75 14.6548 13.4702 14.375 13.125 14.375C12.7798 14.375 12.5 14.6548 12.5 15C12.5 15.3452 12.7798 15.625 13.125 15.625ZM16.25 15C16.25 15.3452 15.9702 15.625 15.625 15.625C15.2798 15.625 15 15.3452 15 15C15 14.6548 15.2798 14.375 15.625 14.375C15.9702 14.375 16.25 14.6548 16.25 15Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuIconUsers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.75 5.3125C3.75 3.41402 5.28902 1.875 7.1875 1.875C9.08598 1.875 10.625 3.41402 10.625 5.3125C10.625 7.21098 9.08598 8.75 7.1875 8.75C5.28902 8.75 3.75 7.21098 3.75 5.3125Z"
      fill="#676A80"
    />
    <path
      d="M11.875 7.1875C11.875 5.6342 13.1342 4.375 14.6875 4.375C16.2408 4.375 17.5 5.6342 17.5 7.1875C17.5 8.7408 16.2408 10 14.6875 10C13.1342 10 11.875 8.7408 11.875 7.1875Z"
      fill="#676A80"
    />
    <path
      d="M1.25 15.9375C1.25 12.6583 3.90831 10 7.1875 10C10.4667 10 13.125 12.6583 13.125 15.9375V15.9396C13.125 15.9728 13.1247 16.0061 13.1241 16.0391C13.1205 16.2545 13.0062 16.4529 12.8216 16.564C11.1756 17.5551 9.24714 18.125 7.1875 18.125C5.12786 18.125 3.19941 17.5551 1.55338 16.564C1.3688 16.4529 1.25448 16.2545 1.25086 16.0391C1.25029 16.0053 1.25 15.9715 1.25 15.9375Z"
      fill="#676A80"
    />
    <path
      d="M14.3749 15.9401C14.3749 15.9802 14.3745 16.0203 14.3738 16.0601C14.3691 16.3423 14.301 16.6148 14.1797 16.86C14.3477 16.8699 14.517 16.875 14.6874 16.875C16.0171 16.875 17.2767 16.5669 18.397 16.0177C18.6029 15.9168 18.7369 15.7113 18.7464 15.4823C18.7487 15.4259 18.7499 15.3693 18.7499 15.3125C18.7499 13.0688 16.931 11.25 14.6874 11.25C14.0653 11.25 13.4759 11.3898 12.9489 11.6397C13.8445 12.8384 14.3749 14.326 14.3749 15.9375V15.9401Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuManageFirmwareIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20"
    width="20"
    viewBox="0 0 512 512"
  >
    <path
      fill="#676A80"
      d="M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    />
  </svg>
);

export const MenuIconIntegrations = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5847 3.41529C15.3643 2.1949 13.3857 2.1949 12.1653 3.41529L8.41529 7.16529C7.1949 8.38568 7.1949 10.3643 8.41529 11.5847C8.67435 11.8438 8.96648 12.0471 9.27752 12.1957C9.58899 12.3445 9.72086 12.7176 9.57207 13.0291C9.42328 13.3405 9.05018 13.4724 8.73871 13.3236C8.30141 13.1147 7.89219 12.8294 7.53141 12.4686C5.82286 10.76 5.82286 7.98995 7.53141 6.28141L11.2814 2.53141C12.99 0.822864 15.76 0.822864 17.4686 2.53141C19.1771 4.23995 19.1771 7.01005 17.4686 8.71859L16.0044 10.1827C15.7604 10.4268 15.3646 10.4268 15.1206 10.1827C14.8765 9.93866 14.8765 9.54293 15.1206 9.29885L16.5847 7.83471C17.8051 6.61432 17.8051 4.63568 16.5847 3.41529ZM10.4279 6.97094C10.5767 6.65948 10.9498 6.52761 11.2613 6.67639C11.6986 6.8853 12.1078 7.17062 12.4686 7.53141C14.1771 9.23995 14.1771 12.01 12.4686 13.7186L8.71859 17.4686C7.01005 19.1771 4.23995 19.1771 2.53141 17.4686C0.822864 15.76 0.822864 12.99 2.53141 11.2814L3.99555 9.81727C4.23963 9.57319 4.63536 9.57319 4.87943 9.81727C5.12351 10.0613 5.12351 10.4571 4.87943 10.7011L3.41529 12.1653C2.1949 13.3857 2.1949 15.3643 3.41529 16.5847C4.63568 17.8051 6.61432 17.8051 7.83471 16.5847L11.5847 12.8347C12.8051 11.6143 12.8051 9.63568 11.5847 8.41529C11.3257 8.15623 11.0335 7.95289 10.7225 7.80431C10.411 7.65552 10.2791 7.28241 10.4279 6.97094Z"
      fill="#676A80"
    />
  </svg>
);

export const MenuQuickAlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.85024 3.50019C6.12648 3.19155 6.10021 2.7174 5.79157 2.44116C5.48292 2.16491 5.00878 2.19118 4.73253 2.49982C3.53158 3.84163 2.69593 5.51948 2.38448 7.37592C2.31594 7.78442 2.59155 8.17114 3.00005 8.23967C3.40855 8.3082 3.79527 8.0326 3.8638 7.6241C4.12691 6.05581 4.83289 4.63686 5.85024 3.50019Z"
      fill="#676A80"
    />
    <path
      d="M19.2669 2.49982C18.9906 2.19118 18.5165 2.16491 18.2078 2.44116C17.8992 2.7174 17.8729 3.19155 18.1492 3.50019C19.1665 4.63686 19.8725 6.05581 20.1356 7.6241C20.2041 8.0326 20.5909 8.3082 20.9994 8.23967C21.4079 8.17114 21.6835 7.78442 21.6149 7.37592C21.3035 5.51948 20.4678 3.84163 19.2669 2.49982Z"
      fill="#676A80"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9999 2.25C8.27203 2.25 5.25 5.27197 5.24989 8.9998L5.24969 9.75C5.24969 11.8731 4.44867 13.8074 3.13114 15.2699C2.96464 15.4547 2.90061 15.71 2.96021 15.9516C3.0198 16.1931 3.19527 16.3893 3.42863 16.4755C4.97275 17.0455 6.58921 17.4659 8.26028 17.7192C8.25339 17.812 8.24989 17.9056 8.24989 18C8.24989 20.0711 9.92882 21.75 11.9999 21.75C14.071 21.75 15.7499 20.0711 15.7499 18C15.7499 17.9056 15.7464 17.812 15.7395 17.7192C17.4104 17.4659 19.0268 17.0455 20.5708 16.4755C20.8041 16.3893 20.9796 16.1931 21.0392 15.9516C21.0988 15.71 21.0347 15.4547 20.8682 15.2699C19.5507 13.8074 18.7497 11.8731 18.7497 9.75V9.04919L18.7499 9C18.7499 5.27208 15.7278 2.25 11.9999 2.25ZM9.74989 18C9.74989 17.9662 9.75063 17.9326 9.75209 17.8993C10.4925 17.966 11.2422 18 11.9997 18C12.7573 18 13.5071 17.9659 14.2477 17.8992C14.2491 17.9326 14.2499 17.9662 14.2499 18C14.2499 19.2426 13.2425 20.25 11.9999 20.25C10.7572 20.25 9.74989 19.2426 9.74989 18Z"
      fill="#676A80"
    />
  </svg>
);

export const CancelIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z"
      fill="#676A80"
    />
  </svg>
);

export const PlusIconWhiteBlueBG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 21.5999C17.302 21.5999 21.6 17.3018 21.6 11.9999C21.6 6.69797 17.302 2.3999 12 2.3999C6.69809 2.3999 2.40002 6.69797 2.40002 11.9999C2.40002 17.3018 6.69809 21.5999 12 21.5999ZM12.9 8.0999C12.9 7.60285 12.4971 7.1999 12 7.1999C11.503 7.1999 11.1 7.60285 11.1 8.0999V11.0999H8.10002C7.60297 11.0999 7.20002 11.5028 7.20002 11.9999C7.20002 12.497 7.60297 12.8999 8.10002 12.8999H11.1V15.8999C11.1 16.397 11.503 16.7999 12 16.7999C12.4971 16.7999 12.9 16.397 12.9 15.8999V12.8999H15.9C16.3971 12.8999 16.8 12.497 16.8 11.9999C16.8 11.5028 16.3971 11.0999 15.9 11.0999H12.9V8.0999Z"
      fill="#212EA3"
    />
  </svg>
);

export const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5001 4.47819V4.70498C17.4548 4.79237 18.4017 4.90731 19.3398 5.04898C19.6871 5.10143 20.0332 5.15755 20.3781 5.2173C20.7863 5.28799 21.0598 5.67617 20.9891 6.0843C20.9184 6.49244 20.5302 6.76598 20.1221 6.69529C20.0525 6.68323 19.9829 6.67132 19.9131 6.65957L18.9077 19.7301C18.7875 21.2931 17.4842 22.5 15.9166 22.5H8.08369C6.51608 22.5 5.21276 21.2931 5.09253 19.7301L4.0871 6.65957C4.0174 6.67132 3.94774 6.68323 3.87813 6.69529C3.47 6.76598 3.08183 6.49244 3.01113 6.0843C2.94043 5.67617 3.21398 5.28799 3.62211 5.2173C3.96701 5.15755 4.31315 5.10143 4.66048 5.04898C5.59858 4.90731 6.5454 4.79237 7.50012 4.70498V4.47819C7.50012 2.91371 8.71265 1.57818 10.3156 1.52691C10.8749 1.50901 11.4365 1.5 12.0001 1.5C12.5638 1.5 13.1253 1.50901 13.6847 1.52691C15.2876 1.57818 16.5001 2.91371 16.5001 4.47819ZM10.3635 3.02614C10.9069 3.00876 11.4525 3 12.0001 3C12.5478 3 13.0934 3.00876 13.6367 3.02614C14.3913 3.05028 15.0001 3.68393 15.0001 4.47819V4.59082C14.0078 4.53056 13.0075 4.5 12.0001 4.5C10.9928 4.5 9.99249 4.53056 9.00012 4.59082V4.47819C9.00012 3.68393 9.6089 3.05028 10.3635 3.02614ZM10.0087 8.97118C9.9928 8.55727 9.64436 8.23463 9.23045 8.25055C8.81654 8.26647 8.49391 8.61492 8.50983 9.02882L8.85599 18.0288C8.8719 18.4427 9.22035 18.7654 9.63426 18.7494C10.0482 18.7335 10.3708 18.3851 10.3549 17.9712L10.0087 8.97118ZM15.4895 9.02882C15.5054 8.61492 15.1828 8.26647 14.7689 8.25055C14.355 8.23463 14.0065 8.55727 13.9906 8.97118L13.6444 17.9712C13.6285 18.3851 13.9512 18.7335 14.3651 18.7494C14.779 18.7654 15.1274 18.4427 15.1433 18.0288L15.4895 9.02882Z"
      fill="#676A80"
    />
  </svg>
);

export const DeleteWarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.535 4.00453C14.0743 1.33638 17.9251 1.33638 19.4645 4.00453L29.2702 21.0012C30.8087 23.6679 28.8841 27.0001 25.8055 27.0001H6.19395C3.11532 27.0001 1.19075 23.6679 2.72921 21.0012L12.535 4.00453ZM16 11C16.5523 11 17 11.4477 17 12V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V12C15 11.4477 15.4477 11 16 11ZM16 22C16.5523 22 17 21.5523 17 21C17 20.4477 16.5523 20 16 20C15.4477 20 15 20.4477 15 21C15 21.5523 15.4477 22 16 22Z"
      fill="#FF737E"
    />
  </svg>
);

export const PenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21.7312 2.26884C20.706 1.24372 19.044 1.24372 18.0188 2.26884L16.8617 3.42599L20.574 7.1383L21.7312 5.98116C22.7563 4.95603 22.7563 3.29397 21.7312 2.26884Z"
      fill="#676A80"
    />
    <path
      d="M19.5133 8.19896L15.801 4.48665L7.40019 12.8875C6.78341 13.5043 6.33002 14.265 6.081 15.101L5.28122 17.7859C5.2026 18.0498 5.27494 18.3356 5.46967 18.5303C5.6644 18.725 5.95019 18.7974 6.21412 18.7188L8.89901 17.919C9.73498 17.67 10.4957 17.2166 11.1125 16.5998L19.5133 8.19896Z"
      fill="#676A80"
    />
    <path
      d="M5.25 5.24999C3.59315 5.24999 2.25 6.59314 2.25 8.24999V18.75C2.25 20.4068 3.59315 21.75 5.25 21.75H15.75C17.4069 21.75 18.75 20.4068 18.75 18.75V13.5C18.75 13.0858 18.4142 12.75 18 12.75C17.5858 12.75 17.25 13.0858 17.25 13.5V18.75C17.25 19.5784 16.5784 20.25 15.75 20.25H5.25C4.42157 20.25 3.75 19.5784 3.75 18.75V8.24999C3.75 7.42156 4.42157 6.74999 5.25 6.74999H10.5C10.9142 6.74999 11.25 6.41421 11.25 5.99999C11.25 5.58578 10.9142 5.24999 10.5 5.24999H5.25Z"
      fill="#676A80"
    />
  </svg>
);

export const MicrosoftIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 0H11.7941V11.2941H0.5V0Z"
      fill="#E43535"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 12.707H11.7941V24.0012H0.5V12.707Z"
      fill="#5EA7FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2058 12.707H24.4999V24.0012H13.2058V12.707Z"
      fill="#FFAF40"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2058 0H24.4999V11.2941H13.2058V0Z"
      fill="#80D25B"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 4.5C14.16 4.5 15.64 5.06 16.79 6.02L20.18 2.63C18.24 0.96 15.55 0 12.5 0 7.91 0 3.98 2.73 2.18 6.68L6.84 10.18C7.67 7.58 9.9 4.5 12.5 4.5Z"
      fill="#EA4335"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.03 9.18H12.5V14.82H18.79C18.24 16.92 16.69 18.27 12.5 18.27 9.9 18.27 7.67 16.2 6.84 13.82L2.18 17.32C3.98 21.27 7.91 24 12.5 24 18.49 24 24.5 20 24.5 12.5 24.5 11.82 24.41 10.96 24.03 9.18Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.84 13.82C6.49 12.87 6.3 11.86 6.3 10.82 6.3 9.78 6.49 8.77 6.84 7.82L2.18 4.32C1.26 6.21 0.5 8.48 0.5 10.82 0.5 13.16 1.26 15.43 2.18 17.32L6.84 13.82Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 18.27C14.88 18.27 16.92 17.41 18.79 14.82L24.03 9.18H12.5V14.82H18.79C18.24 16.92 16.69 18.27 12.5 18.27Z"
      fill="#34A853"
    />
  </svg>
);

export const ExpandopenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.23017 7.20938C5.52875 6.92228 6.00353 6.93159 6.29063 7.23017L10 11.1679L13.7094 7.23017C13.9965 6.93159 14.4713 6.92228 14.7698 7.20938C15.0684 7.49647 15.0777 7.97125 14.7906 8.26983L10.5406 12.7698C10.3992 12.9169 10.204 13 10 13C9.79599 13 9.60078 12.9169 9.45938 12.7698L5.20938 8.26983C4.92228 7.97125 4.93159 7.49647 5.23017 7.20938Z"
      fill="#676A80"
    />
  </svg>
);

export const SortIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3C10.2086 3 10.4077 3.08684 10.5496 3.23966L13.7996 6.73966C14.0815 7.04319 14.0639 7.51774 13.7603 7.7996C13.4568 8.08145 12.9823 8.06387 12.7004 7.76034L10 4.85221L7.2996 7.76034C7.01775 8.06387 6.5432 8.08145 6.23966 7.79959C5.93613 7.51774 5.91856 7.04319 6.20041 6.73966L9.45041 3.23966C9.59232 3.08684 9.79145 3 10 3ZM6.23967 12.2004C6.5432 11.9186 7.01775 11.9361 7.2996 12.2397L10 15.1478L12.7004 12.2397C12.9823 11.9361 13.4568 11.9186 13.7603 12.2004C14.0639 12.4823 14.0815 12.9568 13.7996 13.2603L10.5496 16.7603C10.4077 16.9132 10.2086 17 10 17C9.79145 17 9.59232 16.9132 9.45041 16.7603L6.20041 13.2603C5.91856 12.9568 5.93613 12.4823 6.23967 12.2004Z"
      fill="#676A80"
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18.75 12.75L20.25 12.75C20.6642 12.75 21 12.4142 21 12C21 11.5858 20.6642 11.25 20.25 11.25L18.75 11.25C18.3358 11.25 18 11.5858 18 12C18 12.4142 18.3358 12.75 18.75 12.75Z"
      fill="#212EA3"
    />
    <path
      d="M12 6C12 5.58579 12.3358 5.25 12.75 5.25L20.25 5.25002C20.6642 5.25002 21 5.5858 21 6.00002C21 6.41423 20.6642 6.75002 20.25 6.75002L12.75 6.75C12.3358 6.75 12 6.41421 12 6Z"
      fill="#212EA3"
    />
    <path
      d="M12 18C12 17.5858 12.3358 17.25 12.75 17.25L20.25 17.25C20.6642 17.25 21 17.5858 21 18C21 18.4142 20.6642 18.75 20.25 18.75L12.75 18.75C12.3358 18.75 12 18.4142 12 18Z"
      fill="#212EA3"
    />
    <path
      d="M3.75001 6.75001L5.25001 6.75C5.66422 6.75 6 6.41421 6 5.99999C6 5.58578 5.66421 5.25 5.24999 5.25L3.74999 5.25001C3.33578 5.25002 3 5.58581 3 6.00002C3 6.41424 3.33579 6.75002 3.75001 6.75001Z"
      fill="#212EA3"
    />
    <path
      d="M5.25001 18.75L3.75001 18.75C3.33579 18.75 3 18.4142 3 18C3 17.5858 3.33578 17.25 3.74999 17.25L5.24999 17.25C5.66421 17.25 6 17.5858 6 18C6 18.4142 5.66422 18.75 5.25001 18.75Z"
      fill="#212EA3"
    />
    <path
      d="M3 12C3 11.5858 3.33579 11.25 3.75 11.25H11.25C11.6642 11.25 12 11.5858 12 12C12 12.4142 11.6642 12.75 11.25 12.75H3.75C3.33579 12.75 3 12.4142 3 12Z"
      fill="#212EA3"
    />
    <path
      d="M9 3.75C7.75736 3.75 6.75 4.75736 6.75 6C6.75 7.24264 7.75736 8.25 9 8.25C10.2426 8.25 11.25 7.24264 11.25 6C11.25 4.75736 10.2426 3.75 9 3.75Z"
      fill="#212EA3"
    />
    <path
      d="M12.75 12C12.75 10.7574 13.7574 9.75 15 9.75C16.2426 9.75 17.25 10.7574 17.25 12C17.25 13.2426 16.2426 14.25 15 14.25C13.7574 14.25 12.75 13.2426 12.75 12Z"
      fill="#212EA3"
    />
    <path
      d="M9 15.75C7.75736 15.75 6.75 16.7574 6.75 18C6.75 19.2426 7.75736 20.25 9 20.25C10.2426 20.25 11.25 19.2426 11.25 18C11.25 16.7574 10.2426 15.75 9 15.75Z"
      fill="#212EA3"
    />
  </svg>
);

export const LeftPaginationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697L15.2197 3.96967C15.5126 3.67678 15.9874 3.67678 16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L9.31066 12L16.2803 18.9697C16.5732 19.2626 16.5732 19.7374 16.2803 20.0303C15.9874 20.3232 15.5126 20.3232 15.2197 20.0303L7.71967 12.5303Z"
      fill="#676A80"
    />
  </svg>
);

export const RightPaginationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L8.78033 20.0303C8.48744 20.3232 8.01256 20.3232 7.71967 20.0303C7.42678 19.7374 7.42678 19.2626 7.71967 18.9697L14.6893 12L7.71967 5.03033C7.42678 4.73744 7.42678 4.26256 7.71967 3.96967C8.01256 3.67678 8.48744 3.67678 8.78033 3.96967L16.2803 11.4697Z"
      fill="#676A80"
    />
  </svg>
);

export const DisableIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.25C6.61522 2.25 2.25 6.61522 2.25 12C2.25 17.3848 6.61522 21.75 12 21.75C17.3848 21.75 21.75 17.3848 21.75 12C21.75 6.61522 17.3848 2.25 12 2.25ZM15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H15Z"
      fill="#676A80"
    />
  </svg>
);

export const DropdownDots = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 6C10.5 5.17157 11.1716 4.5 12 4.5C12.8284 4.5 13.5 5.17157 13.5 6C13.5 6.82843 12.8284 7.5 12 7.5C11.1716 7.5 10.5 6.82843 10.5 6ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12ZM10.5 18C10.5 17.1716 11.1716 16.5 12 16.5C12.8284 16.5 13.5 17.1716 13.5 18C13.5 18.8284 12.8284 19.5 12 19.5C11.1716 19.5 10.5 18.8284 10.5 18Z"
      fill="#676A80"
    />
  </svg>
);

export const MinusCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 3C8.8203 3 3 8.8203 3 16C3 23.1797 8.8203 29 16 29C23.1797 29 29 23.1797 29 16C29 8.8203 23.1797 3 16 3ZM20 17C20.5523 17 21 16.5523 21 16C21 15.4477 20.5523 15 20 15H12C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17H20Z"
      fill="#FF737E"
    />
  </svg>
);

export const OnlineSuccess = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#61C26B" />
  </svg>
);

export const OfflineIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#FF737E" />
  </svg>
);

export const HamburgerIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6.75C3 6.33579 3.33579 6 3.75 6H20.25C20.6642 6 21 6.33579 21 6.75C21 7.16421 20.6642 7.5 20.25 7.5H3.75C3.33579 7.5 3 7.16421 3 6.75ZM3 12C3 11.5858 3.33579 11.25 3.75 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H3.75C3.33579 12.75 3 12.4142 3 12ZM3 17.25C3 16.8358 3.33579 16.5 3.75 16.5H20.25C20.6642 16.5 21 16.8358 21 17.25C21 17.6642 20.6642 18 20.25 18H3.75C3.33579 18 3 17.6642 3 17.25Z"
      fill="#676A80"
    />
  </svg>
);

export const AlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.85024 3.50019C6.12648 3.19155 6.10021 2.7174 5.79157 2.44116C5.48292 2.16491 5.00878 2.19118 4.73253 2.49982C3.53158 3.84163 2.69593 5.51948 2.38448 7.37592C2.31594 7.78442 2.59155 8.17114 3.00005 8.23967C3.40855 8.3082 3.79527 8.0326 3.8638 7.6241C4.12691 6.05581 4.83289 4.63686 5.85024 3.50019Z"
      fill="white"
    />
    <path
      d="M19.2669 2.49982C18.9906 2.19118 18.5165 2.16491 18.2078 2.44116C17.8992 2.7174 17.8729 3.19155 18.1492 3.50019C19.1665 4.63686 19.8725 6.05581 20.1356 7.6241C20.2041 8.0326 20.5909 8.3082 20.9994 8.23967C21.4079 8.17114 21.6835 7.78442 21.6149 7.37592C21.3035 5.51948 20.4678 3.84163 19.2669 2.49982Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9999 2.25C8.27203 2.25 5.25 5.27197 5.24989 8.9998L5.24969 9.75C5.24969 11.8731 4.44867 13.8074 3.13114 15.2699C2.96464 15.4547 2.90061 15.71 2.96021 15.9516C3.0198 16.1931 3.19527 16.3893 3.42863 16.4755C4.97275 17.0455 6.58921 17.4659 8.26028 17.7192C8.25339 17.812 8.24989 17.9056 8.24989 18C8.24989 20.0711 9.92882 21.75 11.9999 21.75C14.071 21.75 15.7499 20.0711 15.7499 18C15.7499 17.9056 15.7464 17.812 15.7395 17.7192C17.4104 17.4659 19.0268 17.0455 20.5708 16.4755C20.8041 16.3893 20.9796 16.1931 21.0392 15.9516C21.0988 15.71 21.0347 15.4547 20.8682 15.2699C19.5507 13.8074 18.7497 11.8731 18.7497 9.75V9.04919L18.7499 9C18.7499 5.27208 15.7278 2.25 11.9999 2.25ZM9.74989 18C9.74989 17.9662 9.75063 17.9326 9.75209 17.8993C10.4925 17.966 11.2422 18 11.9997 18C12.7573 18 13.5071 17.9659 14.2477 17.8992C14.2491 17.9326 14.2499 17.9662 14.2499 18C14.2499 19.2426 13.2425 20.25 11.9999 20.25C10.7572 20.25 9.74989 19.2426 9.74989 18Z"
      fill="white"
    />
  </svg>
);

export const QuickAlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="30"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5.85024 3.50019C6.12648 3.19155 6.10021 2.7174 5.79157 2.44116C5.48292 2.16491 5.00878 2.19118 4.73253 2.49982C3.53158 3.84163 2.69593 5.51948 2.38448 7.37592C2.31594 7.78442 2.59155 8.17114 3.00005 8.23967C3.40855 8.3082 3.79527 8.0326 3.8638 7.6241C4.12691 6.05581 4.83289 4.63686 5.85024 3.50019Z"
      fill="#212EA3"
    />
    <path
      d="M19.2669 2.49982C18.9906 2.19118 18.5165 2.16491 18.2078 2.44116C17.8992 2.7174 17.8729 3.19155 18.1492 3.50019C19.1665 4.63686 19.8725 6.05581 20.1356 7.6241C20.2041 8.0326 20.5909 8.3082 20.9994 8.23967C21.4079 8.17114 21.6835 7.78442 21.6149 7.37592C21.3035 5.51948 20.4678 3.84163 19.2669 2.49982Z"
      fill="#212EA3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9999 2.25C8.27203 2.25 5.25 5.27197 5.24989 8.9998L5.24969 9.75C5.24969 11.8731 4.44867 13.8074 3.13114 15.2699C2.96464 15.4547 2.90061 15.71 2.96021 15.9516C3.0198 16.1931 3.19527 16.3893 3.42863 16.4755C4.97275 17.0455 6.58921 17.4659 8.26028 17.7192C8.25339 17.812 8.24989 17.9056 8.24989 18C8.24989 20.0711 9.92882 21.75 11.9999 21.75C14.071 21.75 15.7499 20.0711 15.7499 18C15.7499 17.9056 15.7464 17.812 15.7395 17.7192C17.4104 17.4659 19.0268 17.0455 20.5708 16.4755C20.8041 16.3893 20.9796 16.1931 21.0392 15.9516C21.0988 15.71 21.0347 15.4547 20.8682 15.2699C19.5507 13.8074 18.7497 11.8731 18.7497 9.75V9.04919L18.7499 9C18.7499 5.27208 15.7278 2.25 11.9999 2.25ZM9.74989 18C9.74989 17.9662 9.75063 17.9326 9.75209 17.8993C10.4925 17.966 11.2422 18 11.9997 18C12.7573 18 13.5071 17.9659 14.2477 17.8992C14.2491 17.9326 14.2499 17.9662 14.2499 18C14.2499 19.2426 13.2425 20.25 11.9999 20.25C10.7572 20.25 9.74989 19.2426 9.74989 18Z"
      fill="#212EA3"
    />
  </svg>
);

export const RemoveTag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M6.28033 5.21967C5.98744 4.92678 5.51256 4.92678 5.21967 5.21967C4.92678 5.51256 4.92678 5.98744 5.21967 6.28033L8.93934 10L5.21967 13.7197C4.92678 14.0126 4.92678 14.4874 5.21967 14.7803C5.51256 15.0732 5.98744 15.0732 6.28033 14.7803L10 11.0607L13.7197 14.7803C14.0126 15.0732 14.4874 15.0732 14.7803 14.7803C15.0732 14.4874 15.0732 14.0126 14.7803 13.7197L11.0607 10L14.7803 6.28033C15.0732 5.98744 15.0732 5.51256 14.7803 5.21967C14.4874 4.92678 14.0126 4.92678 13.7197 5.21967L10 8.93934L6.28033 5.21967Z"
      fill="#AB1366"
    />
  </svg>
);

export const PaginationLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.71967 12.5303C7.42678 12.2374 7.42678 11.7626 7.71967 11.4697L15.2197 3.96967C15.5126 3.67678 15.9874 3.67678 16.2803 3.96967C16.5732 4.26256 16.5732 4.73744 16.2803 5.03033L9.31066 12L16.2803 18.9697C16.5732 19.2626 16.5732 19.7374 16.2803 20.0303C15.9874 20.3232 15.5126 20.3232 15.2197 20.0303L7.71967 12.5303Z"
      fill="#676A80"
    />
  </svg>
);

export const PaginationRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2803 11.4697C16.5732 11.7626 16.5732 12.2374 16.2803 12.5303L8.78033 20.0303C8.48744 20.3232 8.01256 20.3232 7.71967 20.0303C7.42678 19.7374 7.42678 19.2626 7.71967 18.9697L14.6893 12L7.71967 5.03033C7.42678 4.73744 7.42678 4.26256 7.71967 3.96967C8.01256 3.67678 8.48744 3.67678 8.78033 3.96967L16.2803 11.4697Z"
      fill="#676A80"
    />
  </svg>
);

export const CalenderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 2.25C7.16421 2.25 7.5 2.58579 7.5 3V4.5H16.5V3C16.5 2.58579 16.8358 2.25 17.25 2.25C17.6642 2.25 18 2.58579 18 3V4.5H18.75C20.4069 4.5 21.75 5.84315 21.75 7.5V18.75C21.75 20.4069 20.4069 21.75 18.75 21.75H5.25C3.59315 21.75 2.25 20.4069 2.25 18.75V7.5C2.25 5.84315 3.59315 4.5 5.25 4.5H6V3C6 2.58579 6.33579 2.25 6.75 2.25ZM20.25 11.25C20.25 10.4216 19.5784 9.75 18.75 9.75H5.25C4.42157 9.75 3.75 10.4216 3.75 11.25V18.75C3.75 19.5784 4.42157 20.25 5.25 20.25H18.75C19.5784 20.25 20.25 19.5784 20.25 18.75V11.25Z"
      fill="#6B6D7D"
    />
  </svg>
);

export const NoAction = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16ZM14.6083 14.0779C16.1366 13.3138 17.8575 14.6942 17.443 16.3519L16.4977 20.1333L16.553 20.1056C17.047 19.8586 17.6477 20.0588 17.8946 20.5528C18.1416 21.0468 17.9414 21.6475 17.4474 21.8944L17.3921 21.9221C15.8638 22.6863 14.143 21.3059 14.5574 19.6482L15.5028 15.8668L15.4474 15.8944C14.9535 16.1414 14.3528 15.9412 14.1058 15.4472C13.8588 14.9533 14.059 14.3526 14.553 14.1056L14.6083 14.0779ZM16 12C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10C15.4477 10 15 10.4477 15 11C15 11.5523 15.4477 12 16 12Z"
      fill="#4080FF"
    />
  </svg>
);

export const LiveCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#61C26B" />
  </svg>
);

export const ScheduledCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#FFC34A" />
  </svg>
);

export const DeclinedCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#FF737E" />
  </svg>
);

export const DraftCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="10"
    viewBox="0 0 9 10"
    fill="none"
  >
    <circle cx="4.5" cy="5" r="4.5" fill="#676A80" />
  </svg>
);
export const AlertsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M28.1353 7.24239C24.6833 8.62335 20.9862 9.52201 17.1266 9.85503C16.0141 9.95102 14.8879 10 13.75 10H12.5C7.66751 10 3.75 13.9175 3.75 18.75C3.75 23.0827 6.89908 26.6799 11.0333 27.3776C11.5904 29.6593 12.3634 31.8563 13.3294 33.9457C14.1028 35.6186 16.1197 36.1458 17.6338 35.2716L18.7277 34.6401C20.1945 33.7932 20.6704 31.9856 20.0145 30.5265C19.623 29.6559 19.2737 28.7623 18.969 27.8483C22.1647 28.2784 25.2364 29.098 28.1353 30.2577C29.3448 26.6421 30 22.7726 30 18.75C30 14.7275 29.3448 10.858 28.1353 7.24239Z"
      fill="#212EA3"
    />
    <path
      d="M30.4344 6.23453C31.7735 10.1607 32.5 14.3705 32.5 18.75C32.5 23.1295 31.7735 27.3393 30.4343 31.2655C30.3424 31.5351 30.2479 31.8035 30.1502 32.0704C29.9129 32.7186 30.2461 33.4366 30.8944 33.6739C31.5426 33.9112 32.2606 33.578 32.4979 32.9297C32.7312 32.2922 32.9493 31.6473 33.1517 30.9955C34.0244 28.1843 34.6045 25.2448 34.8566 22.2129C35.7183 21.3155 36.25 20.0945 36.25 18.75C36.25 17.4056 35.7183 16.1845 34.8566 15.2871C34.6045 12.2553 34.0244 9.3158 33.1517 6.50456C32.9493 5.85275 32.7312 5.20787 32.4979 4.57036C32.2606 3.92207 31.5426 3.5889 30.8944 3.8262C30.2461 4.06351 29.9129 4.78142 30.1502 5.42971C30.2479 5.69658 30.3424 5.96496 30.4344 6.23453Z"
      fill="#212EA3"
    />
  </svg>
);

export const RightIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.59998 12C3.59998 11.5029 4.00292 11.1 4.49998 11.1L17.2655 11.1L12.2762 6.34874C11.9179 6.00423 11.9067 5.43449 12.2512 5.0762C12.5957 4.7179 13.1655 4.70673 13.5238 5.05125L20.1238 11.3512C20.3002 11.5209 20.4 11.7552 20.4 12C20.4 12.2448 20.3002 12.4791 20.1238 12.6487L13.5238 18.9487C13.1655 19.2933 12.5957 19.2821 12.2512 18.9238C11.9067 18.5655 11.9179 17.9958 12.2762 17.6512L17.2655 12.9L4.49998 12.9C4.00292 12.9 3.59998 12.4971 3.59998 12Z"
      fill="#212EA3"
    />
  </svg>
);

export const DeviceManagementIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path d="M32.5 10H7.5V25H32.5V10Z" fill="#212EA3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.625 5C3.89911 5 2.5 6.39911 2.5 8.125V26.875C2.5 28.6009 3.89911 30 5.625 30H16.25V32.5H10C9.30964 32.5 8.75 33.0596 8.75 33.75C8.75 34.4404 9.30964 35 10 35H30C30.6904 35 31.25 34.4404 31.25 33.75C31.25 33.0596 30.6904 32.5 30 32.5H23.75V30H34.375C36.1009 30 37.5 28.6009 37.5 26.875V8.125C37.5 6.39911 36.1009 5 34.375 5H5.625ZM5.625 27.5H34.375C34.7202 27.5 35 27.2202 35 26.875V8.125C35 7.77982 34.7202 7.5 34.375 7.5H5.625C5.27982 7.5 5 7.77982 5 8.125V26.875C5 27.2202 5.27982 27.5 5.625 27.5Z"
      fill="#212EA3"
    />
  </svg>
);

export const MobileLicensingIcon = ({ width = 40, height = 40 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M8 4C6.34315 4 5 5.34315 5 7V33C5 34.6569 6.34315 36 8 36H32C33.6569 36 35 34.6569 35 33V7C35 5.34315 33.6569 4 32 4H8Z"
      fill="#212EA3"
    />

    <rect x="12" y="10" width="16" height="2.2" rx="1" fill="white" />
    <rect x="12" y="15" width="12" height="2.2" rx="1" fill="white" />
    <rect x="12" y="20" width="14" height="2.2" rx="1" fill="white" />

    <circle cx="20" cy="29" r="4" fill="white" />
    <path
      d="M18.3 29.3L19.7 30.7L22 28"
      stroke="#212EA3"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <path
      d="M18.5 32.5L17 35M21.5 32.5L23 35"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 3.125C5.55964 3.125 5 3.68464 5 4.375L5 15.625C5 16.3154 5.55964 16.875 6.25 16.875H11.25C11.9404 16.875 12.5 16.3154 12.5 15.625V12.5C12.5 12.1548 12.7798 11.875 13.125 11.875C13.4702 11.875 13.75 12.1548 13.75 12.5V15.625C13.75 17.0057 12.6307 18.125 11.25 18.125H6.25C4.86929 18.125 3.75 17.0057 3.75 15.625L3.75 4.375C3.75 2.99429 4.86929 1.875 6.25 1.875L11.25 1.875C12.6307 1.875 13.75 2.99429 13.75 4.375V7.5C13.75 7.84518 13.4702 8.125 13.125 8.125C12.7798 8.125 12.5 7.84518 12.5 7.5V4.375C12.5 3.68464 11.9404 3.125 11.25 3.125L6.25 3.125ZM10.4419 7.05806C10.686 7.30214 10.686 7.69787 10.4419 7.94194L9.00888 9.375L18.125 9.375C18.4702 9.375 18.75 9.65482 18.75 10C18.75 10.3452 18.4702 10.625 18.125 10.625L9.00888 10.625L10.4419 12.0581C10.686 12.3021 10.686 12.6979 10.4419 12.9419C10.1979 13.186 9.80214 13.186 9.55806 12.9419L7.05806 10.4419C6.81398 10.1979 6.81398 9.80214 7.05806 9.55806L9.55806 7.05806C9.80214 6.81398 10.1979 6.81398 10.4419 7.05806Z"
      fill="#676A80"
    />
  </svg>
);

export const ChangePasswordIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.875C8.20507 1.875 6.875 3.2673 6.875 5V6.25H6.25C5.00736 6.25 4.00244 7.25492 4.00244 8.49756L4 15.625C4 16.8676 5.00492 17.8726 6.24756 17.8726H13.75C14.9926 17.8726 15.9976 16.8676 15.9976 15.625V8.49756C15.9976 7.25492 14.9926 6.25 13.75 6.25H13.125V5C13.125 3.2673 11.7949 1.875 10 1.875ZM8.125 5C8.125 4.03419 8.91419 3.125 10 3.125C11.0858 3.125 11.875 4.03419 11.875 5V6.25H8.125V5ZM10.625 11.25C10.625 11.5948 10.3452 11.875 10 11.875C9.65482 11.875 9.375 11.5948 9.375 11.25C9.375 10.9052 9.65482 10.625 10 10.625C10.3452 10.625 10.625 10.9052 10.625 11.25ZM10 13.75C10.3452 13.75 10.625 13.4702 10.625 13.125V12.6569C11.0594 12.3877 11.25 11.8498 11.25 11.25C11.25 10.2832 10.4668 9.5 9.5 9.5C8.53321 9.5 7.75 10.2832 7.75 11.25C7.75 11.8498 7.94056 12.3877 8.375 12.6569V13.125C8.375 13.4702 8.65482 13.75 9 13.75H10Z"
      fill="#676A80"
    />
  </svg>
);

export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" />
    <path
      fillRule="evenodd"
      d="M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.75C12.4142 3.75 12.75 4.08579 12.75 4.5V11.25H19.5C19.9142 11.25 20.25 11.5858 20.25 12C20.25 12.4142 19.9142 12.75 19.5 12.75H12.75V19.5C12.75 19.9142 12.4142 20.25 12 20.25C11.5858 20.25 11.25 19.9142 11.25 19.5V12.75H4.5C4.08579 12.75 3.75 12.4142 3.75 12C3.75 11.5858 4.08579 11.25 4.5 11.25H11.25V4.5C11.25 4.08579 11.5858 3.75 12 3.75Z"
      fill="#212EA3"
    />
  </svg>
);

export const TrashIconOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432"
      stroke="#676A80"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ResendAlertIcon = () => (
  <svg
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="#212EA3"
    stroke="#212EA3"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#CCCCCC"
      strokeWidth="0.032"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        fill="#212EA3"
        d="M14.9547098,7.98576084 L15.0711,7.99552 C15.6179,8.07328 15.9981,8.57957 15.9204,9.12636 C15.6826,10.7983 14.9218,12.3522 13.747,13.5654 C12.5721,14.7785 11.0435,15.5888 9.37999,15.8801 C7.7165,16.1714 6.00349,15.9288 4.48631,15.187 C3.77335,14.8385 3.12082,14.3881 2.5472,13.8537 L1.70711,14.6938 C1.07714,15.3238 3.55271368e-15,14.8776 3.55271368e-15,13.9867 L3.55271368e-15,9.99998 L3.98673,9.99998 C4.87763,9.99998 5.3238,11.0771 4.69383,11.7071 L3.9626,12.4383 C4.38006,12.8181 4.85153,13.1394 5.36475,13.3903 C6.50264,13.9466 7.78739,14.1285 9.03501,13.9101 C10.2826,13.6916 11.4291,13.0839 12.3102,12.174 C13.1914,11.2641 13.762,10.0988 13.9403,8.84476 C14.0181,8.29798 14.5244,7.91776 15.0711,7.99552 L14.9547098,7.98576084 Z M11.5137,0.812976 C12.2279,1.16215 12.8814,1.61349 13.4558,2.14905 L14.2929,1.31193 C14.9229,0.681961 16,1.12813 16,2.01904 L16,6.00001 L12.019,6.00001 C11.1281,6.00001 10.6819,4.92287 11.3119,4.29291 L12.0404,3.56441 C11.6222,3.18346 11.1497,2.86125 10.6353,2.60973 C9.49736,2.05342 8.21261,1.87146 6.96499,2.08994 C5.71737,2.30841 4.57089,2.91611 3.68976,3.82599 C2.80862,4.73586 2.23802,5.90125 2.05969,7.15524 C1.98193,7.70202 1.47564,8.08224 0.928858,8.00448 C0.382075,7.92672 0.00185585,7.42043 0.0796146,6.87364 C0.31739,5.20166 1.07818,3.64782 2.25303,2.43465 C3.42788,1.22148 4.95652,0.411217 6.62001,0.119916 C8.2835,-0.171384 9.99651,0.0712178 11.5137,0.812976 Z"
      ></path>{" "}
    </g>
  </svg>
);

export const HelpIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
  >
    <circle 
      cx='12' 
      cy='12' 
      r='10' 
      stroke='currentColor' 
      strokeWidth='2' 
      fill='none' 
    />
    
    <path
      d='M10.125 8.875C10.125 7.83947 10.9645 7 12 7C13.0355 7 13.875 7.83947 13.875 8.875C13.875 9.6632 13.3908 10.3377 12.693 10.638C12.1932 10.8532 11.875 11.272 11.875 11.8125V12'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      fill='none' 
      style={{ fill: 'none' }} 
    />
    
    <circle 
      cx='12' 
      cy='15.5' 
      r='1' 
      fill='currentColor' 
    />
  </svg>
);